var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C14.5 12.6904 15.0596 13.25 15.75 13.25C16.4404 13.25 17 12.6904 17 12C17 11.3096 16.4404 10.75 15.75 10.75C15.0596 10.75 14.5 11.3096 14.5 12Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 12C10.75 12.6904 11.3096 13.25 12 13.25C12.6904 13.25 13.25 12.6904 13.25 12C13.25 11.3096 12.6904 10.75 12 10.75C11.3096 10.75 10.75 11.3096 10.75 12Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 12.6904 7.55964 13.25 8.25 13.25C8.94036 13.25 9.5 12.6904 9.5 12C9.5 11.3096 8.94036 10.75 8.25 10.75C7.55964 10.75 7 11.3096 7 12Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90895 18.796C7.60275 18.6128 7.22214 18.6066 6.91018 18.7798L6.00103 19.2845C5.13579 19.7649 4.17316 18.831 4.62702 17.9516L5.14525 16.9475C5.26493 16.7156 5.28922 16.4461 5.21293 16.1965L5.02645 15.5865C5.00885 15.529 4.98603 15.4732 4.95876 15.4196C4.44501 14.4091 4 13.2118 4 12C4 7.85786 7.85786 4 12 4C16.1421 4 20 7.85786 20 12C20 16.1421 16.1421 20 12 20C10.7559 20 9.27707 19.5309 8.25 19L7.90895 18.796ZM2.30485 20.5145C2.16053 21.2178 2.78224 21.8395 3.48546 21.6952L7.06797 20.9599C7.29201 20.914 7.52425 20.9478 7.73101 21.0456C9.02569 21.6577 10.4729 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5271 2.34232 14.9743 2.9544 16.269C3.05216 16.4758 3.08603 16.708 3.04005 16.932L2.30485 20.5145Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a9b79516177316b57cb1f9ab75aac238.svg";
export { ForwardRef as ReactComponent };